/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
display_init_widgets();
display_display_widgets();`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function display_init_widgets() {
    /****display_init_widgets****/
}
    
function display_display_widgets() {
    /****display_display_widgets****/
}

class DisplayWidget {
    constructor(type, x, y, width, height, screen = 0, color='#ffffff', background_color='#00000', text='', alignment='left') {
        this.type = type
        this.x = x
        this.y = y
        this.width = width
        this.height = height
        this.screen = screen
        this.color = color
        this.background_color = background_color
        this.text = text
        this.alignment = alignment
    }
    
}`,
    });


    return blocks;
};
